<template>
  <div class="drawer">
    <el-drawer
      size="650px"
      :visible.sync="drawerStatus"
      @close="close"
      :title="'寄养退款'"
      :wrapperClosable="false"
    >
    <div class="msgBox">
        <span>退换金额:</span>
        <div class="msgBoxL">
          {{total_price}}
        </div>
      </div>
      <div class="msgBox">
        <span>退换备注:</span>
        <div>
          <el-input
            type="textarea"
            v-model="remark"
            aria-placeholder="不能少于15字"
          ></el-input>
        </div>
      </div>
      
      <div class="msgBox" v-show="isReturnYuE">
        <div style="margin-left: 50px; vertical-align: middle">
          <div class="msgBoxL">收款人姓名:</div>
          <el-input
            v-model="returnAccountParam.name"
            placeholder="请输入收款人姓名"
          ></el-input>

          <div class="msgBoxL">开户行:</div>
          <el-input
            v-model="returnAccountParam.bank_name"
            placeholder="请输入开户行信息"
          ></el-input>

          <div class="msgBoxL">银行卡号:</div>
          <el-input
            v-model="returnAccountParam.card_no"
            placeholder="请输入卡号"
          ></el-input>
        </div>
      </div>
      <div style="height:40px;width:100%"></div>
      <div class="btnBox">
        <div class="btnItem" @click="close">取消</div>
        <div class="btnItem submit" @click="submit">确定</div>
      </div>
    </el-drawer>
  </div>
</template>
  
  <script>
export default {
  props: {
    tabInfo: {
      default: [],
    },
  },
  data() {
    return {
      total_price:'',//退款金额
      payList: [],
      drawerStatus: false,
      formLabelWidth: "80px",
      remark: "",
      isReturnYuE: true, //状态
      // 收款
      returnAccountParam: {
        name: "", //姓名
        bank_name: "", //开户行
        card_no: "",
      },
    };
  },
  computed: {},
  mounted() {
    console.log(this.tabInfo);
    if (this.tabInfo) {
      this.payList = this.tabInfo.pay_info.pay_list;
      this.total_price=this.tabInfo.total_price;
      this.payList.forEach((item) => {
              if (item.pay_type == 6 && item.money !== 0) {
                this.isReturnYuE = false;
              }
              if (item.pay_type == 7 && item.money !== 0) {
                this.isReturnYuE = false;
              }
              if (item.pay_type == 8 && item.money !== 0) {
                this.isReturnYuE = false;
              }
              if (item.pay_type == 9 && item.money !== 0) {
                this.isReturnYuE = false;
              }
              if (item.pay_type == 10 && item.money !== 0) {
                this.isReturnYuE = false;
              }
              if (item.pay_type == 12 && item.money !== 0) {
                this.isReturnYuE = false;
              }
              if (item.pay_type == 14 && item.money !== 0) {
                this.isReturnYuE = false;
              }
              if (item.pay_type == 16 && item.money !== 0) {
                this.isReturnYuE = false;
              }
            });
    }
    this.$nextTick(() => {
      this.drawerStatus = true;
    });
  },
  methods: {
    //创建活体退款
    submit() {
      if (this.remark.length < 20) {
        this.$message({
          type: "error",
          message: "退宠备注不少于20字",
        });
        return;
      }
      let loading = this.$loading();
      let params = {
        orderNo: this.tabInfo.no,
        remark: this.remark,
        isReturnYuE: this.isReturnYuE,
        returnAccountParam: this.returnAccountParam,
      };
      console.log(params);
      this.$http
        .post("/api/ReturnOrder/Return/CreateReturnJiYang", params)
        .then((res) => {
          loading.close();
          console.log(res);
          if (res.code === 0) {
            this.$emit("submit", { type: "close" });
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.delInfo();
          }
        });
    },
    //清空输入框
    delInfo() {
      this.remark = "";
    },

    close() {
      this.$emit("submit", { type: "close" });
    },
  },
};
</script>
  
  <style scoped lang="scss">
.msgBoxL {
  height: 56px;
  line-height: 56px;
}
.drawer {
  width: 0;
  padding: 0 0 0 0;
  ::v-deep.el-drawer {
    .el-drawer__body {
      overflow: auto;
    }
  }
}
.msgBoxL {
    height: 56px;
    line-height: 56px;
  }
.msgBox {
  display: flex;
  padding: 20px;
  & > span {
    // background-color: red;
    display: inline-block;
    padding: 20px;
    text-align: right;
  }
}
.btnBox {
  width: 100%;
  font-size: 14px;
  color: #fff;
  line-height: 40px;
  display: flex;
  position: absolute;
  bottom: 0;
  z-index: 10;
  .btnItem {
    text-align: center;
    width: 100%;
    background-color: #d6d6d6;
    cursor: pointer;
    &.submit {
      background-color: $mainColor;
    }
  }
}
.imgItem {
  position: relative;
  margin-right: 15px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 128px;
  height: 128px;
  line-height: 128px;
  text-align: center;
  background: #f0f0f7;
  border: 1px dashed #b0b0bf;
  border-radius: 8px;
  box-sizing: border-box;
}
.avatar {
  width: 128px;
  height: 128px;
  display: block;
  object-fit: cover;
}
.imgItem i {
  position: absolute;
  top: -10px;
  right: -10px;
}
</style>
  